import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';

import Subscription from '../organisms/Subscription';




//Returning the component
class DashboardSubscription extends Component {
	render() {
		return (
			<div className="dashboardBody">
				<DashboardNavigation />
				<div className="dashboardMainContent">
					<div className="container">
						<Subscription currentPlan="Basic | $15/m" features="5 chatbot" renewal="Your plan will be renewed automatically on 2018-01-29 and you will be charged $15."/>
					</div>
				</div>
		
			</div>
		)
	}
}



export default DashboardSubscription;


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardSubscription.jsx